module.exports = "/images/sub-cancel.png?bd1c2276f7c1972894609c0da3670252";